/**
 * Routes for cash session module
 */

import { lazyWithRetry } from '@tools/utils/lazyWithRetry.ts';

import type { ComponentOrMapping, ComponentPage } from '@cfg/pageRoutes.tsx';

const CashSessionPage = lazyWithRetry(() => import('../pages/CashSessionPage'));

const cashSessionNode = {
  component: CashSessionPage,
} satisfies ComponentPage;

const cashSessionRoutes: ComponentOrMapping = {
  erp: {
    'cash-session': cashSessionNode,
  },
};

export default cashSessionRoutes;
